"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventQueue = exports.EventTypes = void 0;
var Request_1 = require("./Request");
var utils_1 = require("./utils");
exports.EventTypes = {
    variableEvaluated: 'variableEvaluated',
    variableDefaulted: 'variableDefaulted',
};
var EventQueue = /** @class */ (function () {
    function EventQueue(environmentKey, dvcClient, flushEventsMS) {
        this.environmentKey = environmentKey;
        this.client = dvcClient;
        this.eventQueue = [];
        this.aggregateEventMap = {};
        this.flushEventsMS = flushEventsMS || 10 * 1000;
        this.flushInterval = setInterval(this.flushEvents.bind(this), this.flushEventsMS);
    }
    EventQueue.prototype.flushEvents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var eventsToFlush, aggregateEventsToFlush, res, ex_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.client.config) {
                            console.log('DVC Client not initialized to flush events!');
                            return [2 /*return*/];
                        }
                        eventsToFlush = __spreadArray([], this.eventQueue, true);
                        aggregateEventsToFlush = this.eventsFromAggregateEventMap();
                        eventsToFlush.push.apply(eventsToFlush, aggregateEventsToFlush);
                        if (!eventsToFlush.length) {
                            return [2 /*return*/];
                        }
                        console.log("DVC Flush ".concat(eventsToFlush.length, " Events"));
                        this.eventQueue = [];
                        this.aggregateEventMap = {};
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, Request_1.publishEvents)(this.environmentKey, this.client.config, this.client.user, eventsToFlush)];
                    case 2:
                        res = _c.sent();
                        if (res.status !== 201) {
                            (_a = this.eventQueue).push.apply(_a, eventsToFlush);
                        }
                        else {
                            console.log("DVC Flushed ".concat(eventsToFlush.length, " Events."));
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        ex_1 = _c.sent();
                        this.client.eventEmitter.emitError(ex_1);
                        (_b = this.eventQueue).push.apply(_b, eventsToFlush);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Queue DVCAPIEvent for producing
     */
    EventQueue.prototype.queueEvent = function (event) {
        this.eventQueue.push(event);
    };
    /**
     * Queue DVCEvent that can be aggregated together, where multiple calls are aggregated
     * by incrementing the 'value' field.
     */
    EventQueue.prototype.queueAggregateEvent = function (event) {
        var _a;
        (0, utils_1.checkParamDefined)('type', event.type);
        (0, utils_1.checkParamDefined)('target', event.target);
        event.date = Date.now();
        event.value = 1;
        var aggEventType = this.aggregateEventMap[event.type];
        if (!aggEventType) {
            this.aggregateEventMap[event.type] = (_a = {}, _a[event.target] = event, _a);
        }
        else if (aggEventType[event.target]) {
            aggEventType[event.target].value++;
        }
        else {
            aggEventType[event.target] = event;
        }
    };
    /**
     * Turn the Aggregate Event Map into an Array of DVCAPIEvent objects for publishing.
     */
    EventQueue.prototype.eventsFromAggregateEventMap = function () {
        return Object.values(this.aggregateEventMap).map(function (typeMap) { return Object.values(typeMap); }).flat();
    };
    return EventQueue;
}());
exports.EventQueue = EventQueue;
//# sourceMappingURL=EventQueue.js.map